import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const ChartAlt = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function ChartAlt({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.25 13C6.52614 13 6.75 13.2239 6.75 13.5L6.75 20.5C6.75 20.7761 6.52614 21 6.25 21L5.75 21C5.47386 21 5.25 20.7761 5.25 20.5L5.25 13.5C5.25 13.2239 5.47386 13 5.75 13L6.25 13ZM12.25 3C12.5261 3 12.75 3.22386 12.75 3.5L12.75 20.5C12.75 20.7761 12.5261 21 12.25 21L11.75 21C11.4739 21 11.25 20.7761 11.25 20.5L11.25 3.5C11.25 3.22386 11.4739 3 11.75 3L12.25 3ZM18.25 9C18.5261 9 18.75 9.22386 18.75 9.5L18.75 20.5C18.75 20.7761 18.5261 21 18.25 21L17.75 21C17.4739 21 17.25 20.7761 17.25 20.5L17.25 9.5C17.25 9.22386 17.4739 9 17.75 9L18.25 9Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'chart-alt-icon-svg'} iconRender={iconRender} {...props} />;
});

export default ChartAlt;
